import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { generateDependentTableFilters } from '@/main/utils/dependentTablesGenerator';

import { depTableNames, NAME, CRUMB_LABEL_KEY, AKCNI_PRODEJ_ND_POLOZKY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	NdakceId: null as number | null,
	NdakcegenPrp: null as boolean | null,
	PlatnostDat: null as Date | null,
	PlatnostdoDat: null as Date | null,
	SkladOzn: null as number | null,
	Text: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOzn: [],
	},
	depTableNames,
	depTableSettings: {
		[AKCNI_PRODEJ_ND_POLOZKY]: {
			filter(state) {
				return { NdakceId: state.edit.NdakceId, SkladOzn: state.edit.SkladOzn };
			},
		},
	},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
